import React from 'react';
import {
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalHeaderCustom,
  TextHeaderModal,
  TextHeaderCustom,
} from './styles';
import Cancel from '../../static/img/cancel.svg';
import Fechar from '../../static/img/fechar.svg';
import Icon from '../Section/Icon';

export type ModalProps = {
  header?: string;
  customHeader?: string;
  children: React.ReactNode;
  closeButton?: () => void;
  maxWidth?: string;
  contentWidth?: string;
  contentHeight?: string;
  borderRadius?: string;
  paddingTop?: string;
  padding?: string;
  noHeader?: boolean;
};

export default function Modal({
  header,
  customHeader,
  closeButton,
  children,
  maxWidth,
  contentWidth,
  contentHeight,
  borderRadius,
  paddingTop,
  padding,
  noHeader,
}: ModalProps) {
  return (
    <ModalContainer role="dialog" paddingTop={paddingTop}>
      <ModalContent
        maxWidth={maxWidth}
        contentHeight={contentHeight}
        contentWidth={contentWidth}
        borderRadius={borderRadius}
        padding={padding}
      >
        {!noHeader && header && (
          <ModalHeader>
            <TextHeaderModal>{header}</TextHeaderModal>
            {closeButton && (
              <button
                type="button"
                aria-label="Fechar diálogo"
                onClick={closeButton}
              >
                <Icon svg={Cancel} alt="Fechar" />
              </button>
            )}
          </ModalHeader>
        )}
        {!noHeader && !header && (
          <ModalHeaderCustom>
            <TextHeaderCustom>{customHeader}</TextHeaderCustom>
            {closeButton && (
              <button
                type="button"
                aria-label="Fechar diálogo"
                onClick={closeButton}
              >
                <Icon svg={Fechar} alt="Fechar" />
              </button>
            )}
          </ModalHeaderCustom>
        )}
        {children}
      </ModalContent>
    </ModalContainer>
  );
}
